import BuildingInsights_132 from '@carbon/icons-react/es/building--insights-1/32';
import Calendar16 from '@carbon/icons-react/es/calendar/16';
import Edit16 from '@carbon/icons-react/es/edit/16';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PartnerCompany } from 'api/partner/types';
import { Avatar as AvatarAtom } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import { humanise } from 'components/atoms/humanised-date';
import { ProductiveHeading05 } from 'components/styles';

const Avatar = styled(AvatarAtom)`
  height: 80px;
  width: 80px;
`;
const Name = styled.div`
  ${ProductiveHeading05};
`;
const EditButton = styled(Button)`
  padding: 0;
  height: unset;
`;
const NameRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: var(--spacing-05);
`;
const DateAdded = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

const MetaBlock = styled.div`
  color: var(--gray-50);
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;

interface Props {
  partner: PartnerCompany;
  onEdit: () => void;
}
export const PartnerHeader: FC<Props> = ({ partner, onEdit }) => {
  return (
    <Wrapper>
      <Avatar
        size="large"
        src={partner.companyLogoUrl}
        // eslint-disable-next-line react/jsx-pascal-case
        icon={<BuildingInsights_132 />}
      />
      <NameRow>
        <Name>{partner.companyName}</Name>
        <EditButton
          type="link"
          icon={<Edit16 />}
          onClick={onEdit}
          iconPlacement="right"
          size="small"
        >
          <FormattedMessage id="edit" />
        </EditButton>
      </NameRow>
      <MetaBlock>
        <DateAdded>
          <Calendar16 />
          <FormattedMessage
            id="partners.detail.added_date"
            values={{ addedDate: humanise(moment(partner.createdAt)) }}
          />
        </DateAdded>
      </MetaBlock>
    </Wrapper>
  );
};
